import type { FaqStyles, LandingTokens } from '../types';
import { BREAKPOINTS, down } from './breakpoints';
import { sectionHeadSx } from './shared.styles';

export const faqStyles = (t: LandingTokens): FaqStyles => ({
  section: { padding: '30px 0 96px' },
  inner: { maxWidth: 760, margin: '0 auto' },
  head: { ...sectionHeadSx(), marginBottom: '38px' },
  item: {
    borderTop: `1px solid ${t.lineSoft}`,
    padding: '4px 0',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    color: 'inherit',
    '&::before': { display: 'none' },
    '&:first-of-type, &:last-of-type': { borderRadius: 0 },
    '&:last-of-type': { borderBottom: `1px solid ${t.lineSoft}` },
    '&.Mui-expanded': { margin: 0 },
  },
  trigger: {
    padding: '20px 4px',
    minHeight: 0,
    gap: '18px',
    fontFamily: t.serif,
    fontSize: '19.5px',
    fontWeight: 460,
    letterSpacing: '-.01em',
    lineHeight: 1.3,
    borderRadius: 0,
    alignItems: 'center',
    transition: 'color .18s ease',
    '&:hover': { textDecoration: 'none', color: t.brandInk },
    '& .MuiAccordionSummary-content': { margin: 0 },
    '& .MuiAccordionSummary-expandIconWrapper': {
      transition: 'transform .25s cubic-bezier(.2,.7,.2,1)',
    },
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(45deg)',
      '& > *': { backgroundColor: t.ink, borderColor: t.ink, color: t.paper },
    },
  },
  expandIcon: {
    flex: 'none',
    width: 30,
    height: 30,
    borderRadius: '50%',
    border: `1px solid ${t.line}`,
    display: 'grid',
    placeItems: 'center',
    color: t.ink,
    transition: 'background .2s ease, color .2s ease, border-color .2s ease',
    '& svg': { width: 14, height: 14 },
  },
  answer: {
    padding: '0 44px 24px 4px',
    color: t.muted,
    fontSize: 15,
    whiteSpace: 'pre-line',
    [down(BREAKPOINTS.mobile)]: { padding: '0 4px 22px' },
  },
});
